import React, { Fragment, useEffect } from 'react';
import sad from '../../assets/images/other-images/sad.png';
import { Container, Media, Col, Row } from 'reactstrap';
import { BACK_TO_HOME_PAGE } from '../../constant';

const Error500 = () => {
  const redirectToDashboard = () => {
    // window.location.href = '/dashboard/default'; // Redirects to the dashboard page
  };
  // useEffect(() => {
  //   redirectToDashboard();
  // }, []);

  return (
    <Fragment>
      <div
        style={{
          color: '#444',
          margin: 0,
          fontFamily: 'Arial, Helvetica, sans-serif',
          height: '100%',
          backgroundColor: '#fff',
        }}
      >
        <Container fluid style={{ minHeight: '100vh' }}>
          <Row className="justify-content-center align-items-center" style={{ height: '100vh' }}>
            <Col xs="12" md="8" className="text-center">
              <h1 style={{ margin: 0, fontSize: '150px', lineHeight: '150px', fontWeight: 'bold' }}>500</h1>
              <h2 style={{ marginTop: '20px', fontSize: '30px' }}>Not Found</h2>
              <p>
                The page you are attempting to reach is currently not available. This may be because the page does not
                exist or has been moved!
              </p>

              <a href="/dashboard/default" style={{ textDecoration: 'underline' }} onClick={redirectToDashboard}>
                Back to home page
              </a>
            </Col>
          </Row>
        </Container>
      </div>
    </Fragment>
  );
};

export default Error500;
